import { IServices } from "@netent/origin";
import { IHomeState } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

export const homeState: FeatureStateCreator<IHomeState> = (
  services: IServices
): IHomeState =>
  services.game.isHomeButtonVisible()
    ? {
        enabled: true
      }
    : null;
